import { useQuery } from "@tanstack/react-query";
import { getFaqItems, FaqItem } from "../../../api/faqApi";

export const FAQ_ITEMS_QUERY_KEY = ["faq-items"];

export const useFaqItems = () => {
  const { data } = useQuery<FaqItem[]>(FAQ_ITEMS_QUERY_KEY, getFaqItems, { staleTime: Infinity });

  const items = (data ?? []).filter((item) => item.is_active).sort((a, b) => a.display_order - b.display_order);

  return { items };
};
